exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".padding-4percent[data-v-62467b74]{width:200px}.btn[data-v-62467b74]{margin-left:4%}.button-padding[data-v-62467b74]{margin-top:6%}", ""]);

// exports
